import { jsx as _jsx } from "react/jsx-runtime";
import { ExcelIcon, PdfIcon, PowerPointIcon, WordIcon } from '../icons/file-icons';
import { GenericFileIcon, ImageIcon } from '../icons/file-icons-legacy';
/**
 * Renders an appropriate icon based on file type.
 * Uses custom SVG icons for common document types.
 */ export function FileTypeIcon({ contentType, filename, className = '' }) {
    const extension = filename.split('.').pop()?.toLowerCase();
    const iconProps = {
        className: `${className}`
    };
    // Image files
    if (contentType.startsWith('image/')) {
        return /*#__PURE__*/ _jsx(ImageIcon, {
            ...iconProps
        });
    }
    // Document types by extension
    switch(extension){
        case 'pdf':
            return /*#__PURE__*/ _jsx(PdfIcon, {
                ...iconProps
            });
        case 'doc':
        case 'docx':
            return /*#__PURE__*/ _jsx(WordIcon, {
                ...iconProps
            });
        case 'xls':
        case 'xlsx':
        case 'csv':
            return /*#__PURE__*/ _jsx(ExcelIcon, {
                ...iconProps
            });
        case 'ppt':
        case 'pptx':
            return /*#__PURE__*/ _jsx(PowerPointIcon, {
                ...iconProps
            });
        default:
            return /*#__PURE__*/ _jsx(GenericFileIcon, {
                ...iconProps
            });
    }
}
